import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { getAllAccounts } from "../../utils/apiHelperInternal";
import Loader from "../../PhylloConnectComponents/CommonComponents/FullScreenLoader";
import NavBar from "../../PhylloConnectComponents/CommonComponents/NavBar/NavBar";
import { PHYLLO_TOKEN, PHYLLO_USERID } from "../../utils/constants";
import Grow from "@mui/material/Grow";
import Login from "../Login/Login";
import Signup from "../Signup/Signup";
import { CircularProgress } from "@mui/material";
import "./BaseScreen.scss";
import Footer from "../../PhylloConnectComponents/CommonComponents/Footer/Footer";

function BaseScreen() {
  const history = useHistory();
  const [tryForFreeBtnDisabled, setTryFroFreeBtnDisabled] = useState(false);
  const [isLoader, setIsLoader] = useState(true);
  const [loginContainer, setLoginContainer] = useState(false);
  const [signupContainer, setSignupContainer] = useState(false);
  localStorage.setItem("env", process.env.REACT_APP_ENV);

  const navigateToDashboard = async () => {
    const userId = await sessionStorage.getItem(PHYLLO_USERID);
    const token = await sessionStorage.getItem(PHYLLO_TOKEN);
    if (!userId || !token) {
      setIsLoader(false);
      return;
    }
    let accounts = await getAllAccounts();
    accounts = accounts.data;
    if (accounts && accounts.data && accounts.data.length && Boolean(userId)) {
      history.push("/dashboard");
    } else {
      setIsLoader(false);
    }
  };
  useEffect(() => {
    navigateToDashboard();
  });

  return (
    <>
      {isLoader && <Loader />}
      {tryForFreeBtnDisabled && <CircularProgress />}
      {!isLoader && (
        <Grow in={true}>
          <div className="screenBackground">
            {loginContainer && (
              <div className="background-screen">
                <Login close_card={setLoginContainer} />
              </div>
            )}
            {signupContainer && (
              <div className="background-screen">
                <Signup close_card={setSignupContainer} />
              </div>
            )}

            <NavBar isLightMode={true} isLoggedIn={false} history={history} />
            <div className="content-box-home">
              <div className="content-box">
                <h1>Take control of your social accounts</h1>

                <p>
                  View insights and publish posts on your social accounts from a
                  single dashboard.
                </p>
                {!tryForFreeBtnDisabled && (
                  <div className="action-btns">
                    <button
                      disabled={tryForFreeBtnDisabled}
                      className="btn btn-yellow"
                      onClick={() => setSignupContainer(true)}
                    >
                      Try for free
                    </button>
                    <button
                      className="btn btn-light"
                      onClick={() => setLoginContainer(true)}
                    >
                      Login
                    </button>
                  </div>
                )}
              </div>
            </div>
            <Footer />
          </div>
        </Grow>
      )}
    </>
  );
}

export default BaseScreen;
